import { Component, OnInit, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core'
import { Subscription } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { AttachmentCategory, EntityConfiguration } from '../../../models/entity-configuration'
import { EntityData } from '../../../models/entity-data'
import { TableData } from '../../../models/table-data'
import { StoredEntityStateService } from '../../../../entity-store-access/services/stored-entity-state.service'
import { EntityConfigService } from '../../../services/entity-config.service'
import { EntityService } from '../../../services/entity.service'

@Component({
  selector: 'jml-lib-entity-file-attachments',
  templateUrl: './entity-file-attachments.component.html',
  styleUrls: ['./entity-file-attachments.component.scss']
})
export class EntityFileAttachmentsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() ownerType: string
  @Input() ownerId: number
  @Input() categories: AttachmentCategory[]

  subscriptions: Subscription[] = []
  fileTableData: TableData[]
  showZombieAttachmentTab: boolean

  constructor(
    private entityService: EntityService,
    private entityConfigService: EntityConfigService,
    private storedEntityWrapper: StoredEntityStateService
  ) {}

  ngOnInit() {
    this.init()
    this.subscriptions.push(
      this.storedEntityWrapper.entityUpdated$
        .pipe(
          tap(() => {
            this.fileTableData?.forEach((ftd) => ftd.triggerRefresh.next())
          })
        )
        .subscribe()
    )
  }

  init() {
    this.fileTableData = []
    this.showZombieAttachmentTab = false

    if (this.categories) {
      // initialze FileTable for each category
      const attachmentCatHrid: string[] = []
      this.categories.forEach((category) => {
        this.initFileTable(category.attachmentCatHrid)
        attachmentCatHrid.push(category.attachmentCatHrid)
      })
      this.initFileTable(null, attachmentCatHrid)
    } else {
      // no categories
      this.initFileTable()
    }
  }

  // no param set: no attachment category defined => get all file attachments
  // only catHrid is set: get file attachments for category
  // only excludedCats[] is set: get all file attachments excluding the ones belonging to the specified categories ("zombie attachments")
  initFileTable(catHrid?: string, excludedCats?: string[]) {
    console.log('calling initFileTable')
    const dataSource$ = this.entityService
      .postEntityDataFromUrl('/attachment/all', {
        attachmentType: 'FileAttachment',
        attachmentCategory: catHrid,
        ownerType: this.ownerType,
        ownerId: this.ownerId,
        excludeAttachmentCategories: excludedCats
      })
      .pipe(
        // Need to convert Date strings to Date type
        switchMap((entityData) =>
          this.entityConfigService.getConfig$('FileAttachment').pipe(
            map((config) => {
              console.log('mapping config', config, entityData)
              let data: [EntityConfiguration, EntityData]
              data = [config, entityData]
              return data
            })
          )
        ),
        map((data) => {
          const config = data[0]
          const entityData = data[1]
          return this.entityService.convertEntityDataDateFieldsToDate(config.fields, entityData)
        })
      )

    if (excludedCats) {
      this.subscriptions.push(
        dataSource$.subscribe((entityData) => {
          entityData.data.length === 0 ? (this.showZombieAttachmentTab = false) : (this.showZombieAttachmentTab = true)
        })
      )
    }

    const tableData = new TableData('FileAttachment')
      .setScrollable()
      .setScrollHeight('175px')
      .setDataSource(dataSource$)
      .hideHeader()
      .disablePagination()

    this.fileTableData.push(tableData)
  }

  // called when any data-bound property of a directive changes, e.g. when another entity is selected
  ngOnChanges(changes: SimpleChanges) {
    if (!changes.ownerId.firstChange) {
      this.init()
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe())
  }
}
